import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ShieldWarning, X } from '@phosphor-icons/react';

const ForgeMasterWipe = () => {
  const [accounts, setAccounts] = useState([]);
  const [confirmFor, setConfirmFor] = useState(null);
  const [confirmText, setConfirmText] = useState('');

  useEffect(() => {
    axios.get('/api/forge/accounts', { withCredentials: true }).then(r => setAccounts(r.data)).catch(() => {});
  }, []);

  const doWipe = async () => {
    if (confirmText !== 'WIPE') return toast.error('Type WIPE to confirm');
    try {
      const res = await axios.post(`/api/forge/accounts/${confirmFor.id}/wipe`, {}, { withCredentials: true });
      toast.success(`Wiping ${res.data.count} tracked site(s) in the background.`);
      setConfirmFor(null); setConfirmText('');
    } catch (e) { toast.error(e.response?.data?.detail || 'Wipe failed'); }
  };

  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-2 duration-500">
      <div>
        <h1 className="text-4xl font-black text-red-500 flex items-center gap-3"><ShieldWarning size={36} weight="fill" /> MASTER WIPE</h1>
        <p className="text-slate-400 font-mono">Delete all OnForge sites tracked for an account. Servers are preserved.</p>
      </div>

      <div className="border border-red-500/30 bg-red-500/5 p-6">
        <p className="text-red-400 text-sm font-mono">This deletes the Forge <strong>sites</strong> tracked by this deployer (and removes their records). It does NOT delete your servers. This cannot be undone.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {accounts.map(acc => (
          <div key={acc.id} className="border border-white/10 bg-card p-6 flex justify-between items-center">
            <div>
              <h3 className="text-lg font-bold">{acc.label}</h3>
              <p className="text-xs font-mono text-slate-500">{acc.forge_email}</p>
            </div>
            <button onClick={() => { setConfirmFor(acc); setConfirmText(''); }} data-testid={`forge-wipe-btn-${acc.id}`} className="bg-red-500/10 text-red-500 border border-red-500/30 hover:bg-red-500 hover:text-white transition-colors px-4 py-2 font-bold text-sm uppercase tracking-wider">Wipe Sites</button>
          </div>
        ))}
        {accounts.length === 0 && <div className="col-span-full p-8 border border-dashed border-white/20 text-center text-slate-500">No accounts.</div>}
      </div>

      {confirmFor && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-card border border-red-500/50 p-8 w-full max-w-md relative">
            <button onClick={() => setConfirmFor(null)} className="absolute top-4 right-4 text-slate-400 hover:text-white"><X size={24} /></button>
            <h2 className="text-2xl font-bold mb-4 text-red-500">CONFIRM WIPE</h2>
            <p className="text-slate-400 text-sm mb-4">Delete all tracked sites for <strong className="text-white">{confirmFor.label}</strong>? Type <strong className="text-red-500">WIPE</strong> to confirm.</p>
            <input value={confirmText} onChange={(e) => setConfirmText(e.target.value)} data-testid="forge-wipe-confirm-input" className="w-full bg-[#0A0B0E] border border-red-500/30 p-3 font-mono mb-4 focus:outline-none focus:border-red-500" />
            <button onClick={doWipe} data-testid="forge-wipe-confirm-btn" className="w-full bg-red-500 text-white font-bold py-3 hover:bg-red-600 transition-colors">WIPE NOW</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ForgeMasterWipe;
